import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { MatDialog } from "@angular/material";
import { MyserviceService } from "../../provider/myservice.service";
import Swal from "sweetalert2";
// import OlMap from "ol/map";
// import OlTileWMS from "ol/source/TileWMS";
// import OlTileLayer from "ol/layer/tile";
// import OlView from "ol/View";
// import VectorSource from "ol/source/Vector";
// import VectorLayer from "ol/layer/Vector";
// import Point from 'ol/geom/Point.js';
// import Feature from 'ol/Feature';
// import Icon from 'ol/style/icon';
// import Style from 'ol/style/Style';
// declare var ol: any;
import * as L from "leaflet";
import axios from "axios";

import { source, transform, vectorLayer } from "../../global/style";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { cus_lange } from "../../language/customer";
import { ActivatedRoute, Router } from "@angular/router";
import { BsLocaleService } from "ngx-bootstrap/datepicker";
import { defineLocale } from "ngx-bootstrap/chronos";
import { enGbLocale } from "ngx-bootstrap/locale";
import { thLocale } from "ngx-bootstrap/locale";

import { HttpClient, HttpHeaders } from "@angular/common/http";

defineLocale("engb", enGbLocale);
defineLocale("th", thLocale);

declare var url;

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class customer {
  customer_id: string;
  customer_name: string;
  customer_surname: string;
  mobile: string;
  email: string;
}

@Component({
  selector: "app-customer",
  templateUrl: "./customer.component.html",
  styleUrls: ["./customer.component.scss"],
})
export class CustomerComponent implements OnInit {
  //open layer
  // map: OlMap;
  // source: OlTileWMS;
  // layer: OlTileLayer;
  // view: OlView;
  // markerSource: VectorSource
  temp_lat:"";
  temp_lon:"";
  zone_name:"";
  zone_id: "";
  dtOptions: DataTables.Settings = {};
  customers: customer[];
  b: boolean = false;
  a: boolean = false;
  mapbox: any = null;
  map;
  lat = 19.14008388;
  lon = 99.91081981;
  marker;
  polygon;
  submitted = false;
  select_rd_2 = false;
  select_rd_1 = true;
  //language
  lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
  language: any;
  //variable
  all_customer: any[];
  customerss: any[];
  all_place: any[];
  show_radio_btn = true;
  places: any[];
  isLoading = true;
  max_place_id: any;
  place_id: "";
  search_place_address: "";
  place_pic: "";
  search_text = "";
  search_place = "";
  request_ids = {
    customer_name: "",
    customer_surname: "",
    mobile: "",
    place_type_description: "",
    request_desc: "",
  };
  geojson: any = null;
  customer_mobile = "";
  customer_request = {
    request_id: "",
    customer_name: "",
    lat: "",
    lon: "",
    coordinates: "",
    remark: "",
    flag: "",
    user_id: "",
    request_date: "",
    request_type: "",
    request_desc: "",
  };
  view_place_customer = {
    customer_id: "",
    customer_name: "",
    mobile: "",
    email: "",
    customer_surname: "",
    customer_prefix: "",
    customer_middle_name: "",
    customer_prosonalcard: "",
    customer_nationality: "",
    customer_race: "",
    customer_birthday: "",
    created_date: "",
    edit_date: "",
  };
  edit_customer = {
    customer_id: "",
    customer_name: "",
    mobile: "",
    email: "",
    customer_surname: "",
    customer_prefix: "",
    customer_middle_name: "",
    customer_prosonalcard: "",
    customer_nationality: "",
    customer_race: "",
    customer_birthday: "",
    created_date: "",
    edit_date: "",
  };
  place_customer = {
    customer_id: "",
    place_id: "",
    place_description: "",
    place_address: "",
    tambol: "",
    amphur: "",
    province: "",
    postcode: "",
    remark: "",
    place_type_id: "",
    lat: "",
    lon: "",
    place_pic: "",
    place_mobile: "",
    place_owner: "",
  };
  actions = [
    {
      id: 0,
      action_type: {
        TH: "แสดงรายการข้อมูลผู้เสียค่าธรรมเนียม",
        EN: "View customer data",
      },
      hostUrl: "customer/get",
    },
    {
      id: 1,
      action_type: {
        TH: "เพิ่มข้อมูลผู้เสียค่าธรรมเนียม",
        EN: "Add customer data",
      },
      /*hostUrl:"add_customer"*/ hostUrl: "customer/create",
    },
    {
      id: 2,
      action_type: {
        TH: "แก้ไขข้อมูลผู้เสียค่าธรรมเนียม",
        EN: "Edit customer data",
      },
      hostUrl: "customer/update",
    },
    {
      id: 3,
      action_type: {
        TH: "แสดงรายการที่อยู่ของผู้เสียค่าธรรมเนียม",
        EN: "View customer place",
      },
      hostUrl: "customer-place/get",
    },
    {
      id: 4,
      action_type: {
        TH: "เพิ่มข้อมูลที่อยู่ของผู้เสียค่าธรรมเนียม",
        EN: "Add customer place",
      },
      hostUrl: "customer-place/create",
    },
    {
      id: 5,
      action_type: {
        TH: "แก้ไขข้อมูลที่อยู่ของผู้เสียค่าธรรมเนียม",
        EN: "Edit customer place",
      },
      hostUrl: "customer-place/update",
    },
  ];
  name_prefixs = [
    {
      value: 1,
      name: { TH: "นาย", EN: "Mr" },
    },
    {
      value: 2,
      name: { TH: "นางสาว", EN: "Miss" },
    },
  ];
  action = this.actions[0];
  config = {
    keyboard: true,
  };
  modalRef: BsModalRef;
  place_ids: any;
  place_types: any;
  provinces: any;
  tambons: any;
  amphurs: any;
  postcodes: any;
  prefixs: any;
  temp_tambon: any;
  temp_amphoe: any;
  temp_province: any;
  temp_postcod: any;

  httpOptions: any;
  token = "";
  database = "";
  admin_id = "";
  constructor(
    private http: HttpClient,
    private service: MyserviceService,
    private chRef: ChangeDetectorRef,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private localeService: BsLocaleService,
    private modalService: BsModalService
  ) {
    this.language = cus_lange[this.lang];
  }

  ngOnInit() {
    this.a = true;
    this.service.postData({}, "market-place/get").then((result: any) => {
      if (!result.code) {
        this.geojson = result.data;
      }
    });
    this.service.postData({}, "name-prefix/get").then((result: any) => {
      if (!result.code) {
        this.prefixs = result.data;
      }
    });
    this.getCustomerData();
    this.service
      .postData(
        { province: "all", tambon: "", amphur: "", postcode: "" },
        "get_location"
      )
      .then((result: any) => {
        // //console.log(result);
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.provinces = result.data;
        }
      });
    this.route.queryParams.subscribe((params) => {
      this.lang = params["lang"];
      if (params["lang"] != "EN" && params["lang"] != "TH") {
        this.lang = localStorage.getItem("lang") == "EN" ? "EN" : "TH";
        this.language = cus_lange[this.lang];
        this.localeService.use(this.lang.toLowerCase());
      } else {
        this.language = cus_lange[params["lang"]];
        this.localeService.use(params["lang"].toLowerCase());
        localStorage.setItem("lang", params["lang"]);
      }
    });
  }

  searchPlaceChange(e) {
    this.place_ids = [];
    this.place_id = "";
    this.customer_request.request_id = "";
    if (this.search_place_address.length >= 5) {
      this.service
        .postData(
          { search: this.search_place_address },
          "customer-place/get-all"
        )
        .then((result: any) => {
          this.isLoading = false;
          this.place_ids = result.data;
        });
    }
  }

  async select_request(id) {
    debugger
    this.search_place_address = "";
    this.place_id = "";
    const place_id = this.place_customer.place_id;
    this.place_customer = {
      customer_id: "",
      place_id: `${place_id}`,
      place_description: "",
      place_address: "",
      tambol: "",
      amphur: "",
      province: "",
      postcode: "",
      remark: "",
      place_type_id: "",
      lat: "",
      lon: "",
      place_pic: "",
      place_mobile: "",
      place_owner: "",
    };
    console.log(id);
    if (id == "") {
      this.place_customer.lat = "";
      this.place_customer.lon = "";
    } else {
      // debugger
      await this.service
        .postData({ request_id: id }, "customer-request/get-customer-request")
        .then(async (result: any) => {
          this.customer_request.customer_name = result.data.customer_name;
          this.customer_request.remark = result.data.remark;
          this.place_customer.lat = result.data.lat;
          this.place_customer.lon = result.data.lon;
          this.customer_request.coordinates = result.data.coordinates;
          this.place_customer.place_type_id = result.data.place_type_id;
          console.log(result);
          if (result.data.flag_use == "0") {
            this.customer_request.flag = "ไม่อนุมัติ";
          }
          if (result.data.flag_use == "2") {
            this.customer_request.flag = "อนุมัติ";
          }
          if (result.data.flag_use == "1") {
            this.customer_request.flag = "รอดำเนินการ";
          }
          const latValue = this.place_customer.lat;
          const longValue = this.place_customer.lon;
          let address = await axios.get(
            `https://www.deemap.com/DeeMap2WS_GC_dtc-ws/geocodingWithPOI.jsp?lat=` +
              latValue +
              `&lon=` +
              longValue +
              `&radius=1`
          );
          this.admin_id = address.data.tambon[0].ADMIN_CODE;
          this.temp_tambon = address.data.tambon[0].TAM_TNAME;
          this.temp_amphoe = address.data.tambon[0].AMP_TNAME;
          this.temp_province = address.data.tambon[0].PROV_TNAME;
          this.temp_postcod = address.data.tambon[0].POSTCOD;

          console.log(this.admin_id);
          console.log(this.temp_tambon);
          console.log(this.temp_amphoe);
          console.log(this.temp_province);

          var customIcon = L.icon({
            iconUrl: "../../../assets/img/marker-icon-2x.png",
            iconSize: [30, 45],
            iconAnchor: [23, 35],
            popupAnchor: [-2, -38],
          });
          if (this.marker) {
            this.map.removeLayer(this.marker);
          }
          if (this.polygon) {
            this.map.removeLayer(this.polygon);
          }

          let data_geojson = {
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                properties: {},
                geometry: {
                  type: "MultiPolygon",
                  coordinates: JSON.parse(result.data.coordinates),
                },
              },
            ],
          };
          console.log(data_geojson);
          this.polygon = L.geoJSON(data_geojson, {
            pointToLayer: function (feature, latlng) {
              var marker = L.marker(latlng);
              marker.bindPopup(
                `<p>Feature properties: ${JSON.stringify(
                  feature.properties
                )}</p>`
              );
              return marker;
            },
          }).addTo(this.map);

          await this.service.postData({ latitude: this.lat, longitude: this.lon }, "zone/get_zone_form_lat_lon")
          .then((result: any) => {
            console.log(result);
            this.zone_id = result.data.zoneId;
            this.zone_name = result.data.zoneName;

          });
        
          let marker = L.marker([this.lat, this.lon], { icon: customIcon });
          marker.bindPopup(
          `<p style="font-size: 12px;">
          ชื่อ: ${result.data.customer_name}<br>
          นามสกุล: ${result.data.customer_surname}<br>
          รายละเอียด: ${result.data.request_desc}<br>
          ชนิดที่อยู่: ${result.data.place_type_description}<br>
          เขตที่อยู่: ${this.zone_name}<br>
          </p>`
          );

          marker.addTo(this.map);
          marker.openPopup();
          this.marker = marker;
          this.map.setView([this.lat, this.lon], 100);
          // this.service.postData({province: this.place_customer.province, amphur: "all",  tambon: "", postcode: "",},"get_location")
          // .then((result: any) => {
          //   if (result.code) {
          //     Swal.fire(result.message, "", "error");
          //   } else {
          //     this.amphurs = result.data;
          //   }
          // });
        });
    }
  }

  select_place(id) {
    this.customer_request.request_id = "";
    console.log(id);
    if (id == "") {
      this.place_customer.lat = "";
      this.place_customer.lon = "";
    } else {
      this.service
        .postData({ place_id: id }, "customer-place/get-all")
        .then((result: any) => {
          console.log(result.data);
          this.place_customer.lat = result.data.lat;
          this.place_customer.lon = result.data.lon;
          this.place_customer.place_description = result.data.place_description;
          this.place_customer.place_address = result.data.place_address;
          this.place_customer.place_mobile = result.data.place_mobile;
          this.place_customer.remark = result.data.remark;
          this.place_customer.place_type_id = result.data.place_type_id;
          this.place_customer.place_owner = result.data.place_owner;
          this.place_customer.province = result.data.province_en;
          this.place_customer.amphur = result.data.amphur_en;
          this.place_customer.tambol = result.data.tambon_en;
          this.place_customer.postcode = result.data.admin_id;
          this.place_customer.place_pic = result.data.place_pic;

          this.lat = result.data.lat;
          this.lon = result.data.lon;
          var customIcon = L.icon({
            iconUrl: "../../../assets/img/marker-icon-2x.png",
            iconSize: [30, 45],
            iconAnchor: [23, 35],
            popupAnchor: [-2, -38],
          });
          if (this.marker) {
            // check
            this.map.removeLayer(this.marker); // remove
            this.map.removeControl(this.marker); // remove
            // this.marker = L.marker([this.lat, this.lon]).addTo(this.map);
            let marker = L.marker([this.lat, this.lon], {
              icon: customIcon,
            }).addTo(this.map);

            this.map.panTo([this.lat, this.lon]);
          }

          if (this.polygon) {
            let x = result.data.coordinates
              .toString()
              .replace(/MultiPolygon /g, "")
              .replace(/\[/gi, "")
              .replace(/\]/gi, "")
              .replace(" ", "")
              .split(",");
            console.log(x);
            if (x != "-") {
              let xyz;
              for (let b = 0; b <= x.length - 1; b += 2) {
                if (xyz == undefined) {
                  xyz = "[" + x[b + 1] + "," + x[b] + "]";
                  this.lat = x[b + 1];
                  this.lon = x[b];
                } else {
                  xyz += ",[" + x[b + 1] + "," + x[b] + "]";
                }
              }

              this.map.removeLayer(this.polygon); // remove
              this.map.removeControl(this.polygon); // remove
              this.polygon = L.polygon(JSON.parse("[[[" + xyz + "]]]")).addTo(
                this.map
              );
            }
          }

          this.service
            .postData(
              {
                province: this.place_customer.province,
                amphur: "all",
                tambon: "",
                postcode: "",
              },
              "get_location"
            )
            .then((result: any) => {
              if (result.code) {
                Swal.fire(result.message, "", "error");
              } else {
                this.amphurs = result.data;
              }
            });
          this.service
            .postData(
              {
                province: this.place_customer.province,
                amphur: this.place_customer.amphur,
                tambon: "all",
                postcode: "",
              },
              "get_location"
            )
            .then((result: any) => {
              if (result.code) {
                Swal.fire(result.message, "", "error");
              } else {
                this.tambons = result.data;
              }
            });
          this.service
            .postData(
              {
                province: this.place_customer.province,
                amphur: this.place_customer.amphur,
                tambon: this.place_customer.tambol,
                postcode: "all",
              },
              "get_location"
            )
            .then((result: any) => {
              if (result.code) {
                Swal.fire(result.message, "", "error");
              } else {
                this.postcodes = result.data;
              }
            });
        });
    }
  }

  select_province() {
    // alert(this.place_customer.province);
    this.place_customer.amphur = "";
    this.place_customer.tambol = "";
    this.place_customer.postcode = "";
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: "all",
          tambon: "",
          postcode: "",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.amphurs = result.data;
        }
      });
  }
  check_number(e) {
    // alert(e.target.value)
    // alert(this.edit_customer.mobile)
    if (!parseInt(this.customer_mobile)) {
      this.customer_mobile = this.edit_customer.mobile;
    } else {
      this.edit_customer.mobile = this.customer_mobile;
    }
    // if(parseInt()){
    //   e.preventdefault()
    // }else{

    // }
    // alert(11);
    // alert(e.target.value)
  }
  select_amphur() {
    this.place_customer.tambol = "";
    this.place_customer.postcode = "";
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: this.place_customer.amphur,
          tambon: "all",
          postcode: "",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.tambons = result.data;
        }
      });
  }
  select_tambon() {
    this.place_customer.postcode = "";
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: this.place_customer.amphur,
          tambon: this.place_customer.tambol,
          postcode: "all",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.postcodes = result.data;
        }
      });
  }
  openModal(template, place) {
    this.modalRef = this.modalService.show(template, this.config);
    this.modalRef.setClass("modal-lg");
    this.place_pic = place.place_pic;
  }
  onFileChange(e) {
    const file = e.target.files[0];

    var reader = new FileReader();
    //console.log(file)
    reader.onload = (e: any) => {
      // $('#blah').attr('src', e.target.result);
      //console.log(e.target.result);
      var base64 = e.target.result;
      var index = base64.indexOf("base64,");
      //console.log(index)

      this.place_customer.place_pic = base64.substring(
        index + 7,
        base64.length
      );
    };

    reader.readAsDataURL(file);
    // //console.log(e);
  }
  onSearchChange(event) {
    this.customers = this.all_customer.filter((item) => {
      return (
        item.customer_id.toLowerCase().indexOf(this.search_text.toLowerCase()) >
          -1 ||
        item.customer_name
          .toLowerCase()
          .indexOf(this.search_text.toLowerCase()) > -1 ||
        item.mobile.toLowerCase().indexOf(this.search_text.toLowerCase()) >
          -1 ||
        item.email.toLowerCase().indexOf(this.search_text.toLowerCase()) > -1
      );
    });
  }
  onSearchPlace(event) {
    //debugger;
    //console.log(this.search_place);
    this.places = this.all_place.filter((item) => {
      return (
        item.customer_id
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item.place_id.toLowerCase().indexOf(this.search_place.toLowerCase()) >
          -1 ||
        item.place_description
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item.place_address
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item["tambon_" + this.lang.toLowerCase()]
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item["amphur_" + this.lang.toLowerCase()]
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item["province_" + this.lang.toLowerCase()]
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        item.postcode.toLowerCase().indexOf(this.search_place.toLowerCase()) >
          -1 ||
        item.remark.toLowerCase().indexOf(this.search_place.toLowerCase()) >
          -1 ||
        item.place_type_description
          .toLowerCase()
          .indexOf(this.search_place.toLowerCase()) > -1 ||
        (item.lat + "").toLowerCase().indexOf(this.search_place.toLowerCase()) >
          -1 ||
        (item.lon + "").toLowerCase().indexOf(this.search_place.toLowerCase()) >
          -1
      );
    });
  }
  getCustomerData() {
    this.search_text = "";
    this.search_place = "";
    this.places = this.all_place;
    this.submitted = false;
    this.isLoading = true;
    this.action = this.actions[0];
    this.edit_customer = {
      customer_id: "",
      customer_name: "",
      mobile: "",
      email: "",
      customer_surname: "",
      customer_prefix: "",
      customer_middle_name: "",
      customer_prosonalcard: "",
      customer_nationality: "",
      customer_race: "",
      customer_birthday: "",
      created_date: "",
      edit_date: "",
    };
    this.view_place_customer = {
      customer_id: "",
      customer_name: "",
      mobile: "",
      email: "",
      customer_surname: "",
      customer_prefix: "",
      customer_middle_name: "",
      customer_prosonalcard: "",
      customer_nationality: "",
      customer_race: "",
      customer_birthday: "",
      created_date: "",
      edit_date: "",
    };
    this.place_customer = {
      customer_id: "",
      place_id: "",
      place_description: "",
      place_address: "",
      tambol: "",
      amphur: "",
      province: "",
      postcode: "",
      remark: "",
      place_type_id: "",
      lat: "",
      lon: "",
      place_pic: "",
      place_mobile: "",
      place_owner: "",
    };
    this.service.postData({ topic: "all-row" }, this.action.hostUrl).then(
      (data: any) => {
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        window.location.href = this.service.start_host;
      }
    );

    // New get to datatable
    if (sessionStorage.getItem("municipality") != undefined) {
      this.database =
        JSON.parse(sessionStorage.getItem("municipality")).municipality_id +
        "_fee";
    }

    if (sessionStorage.getItem("token") != undefined) {
      this.token = sessionStorage.getItem("token");
    }

    this.httpOptions = {
      headers: new HttpHeaders({
        "Content-Type": "application/json; charset=utf-8",
        "x-access-token": this.token,
        database: this.database,
      }),
    };
    console.log(url + "customer/get_to_datatable");
    const that = this;
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: 10,
      serverSide: true,
      processing: true,
      language: {
        emptyTable: "NO Records",
        zeroRecords: "",
      },
      ajax: (dataTablesParameters: any, callback) => {
        that.http
          .post<DataTablesResponse>(
            url + "customer/get_to_datatable",
            dataTablesParameters,
            {
              headers: new HttpHeaders({
                "Content-Type": "application/json; charset=utf-8",
                "x-access-token": this.token,
                database: this.database,
              }),
            }
          )
          .subscribe((resp) => {
            that.customerss = resp.data;
            this.isLoading = false;
            callback({
              recordsTotal: resp.recordsTotal,
              recordsFiltered: resp.recordsFiltered,
              data: [],
            });
          });
      },
      columns: [
        { data: "customer_id" },
        { data: "customer_name" },
        { data: "customer_surname" },
        { data: "mobile" },
        { data: "email" },
        { data: "" },
      ],
    };
  }

  add() {
    this.action = this.actions[1];
    this.isLoading = true;
    this.service.postData({}, "/customer/getId").then((result: any) => {
      this.isLoading = false;
      if (result.hasErr) {
        Swal.fire(
          this.language.cant_load_data,
          this.language.cant_save_data,
          "error"
        );
      } else {
        this.edit_customer.customer_id = result.max_id;
      }
    });
  }
  back() {
    this.getCustomerData();
  }
  edit(customer_data) {
    this.action = this.actions[2];
    this.edit_customer = JSON.parse(JSON.stringify(customer_data));
    this.customer_mobile = this.edit_customer.mobile;
  }
  save_customer() {
    this.submitted = true;
    this.edit_customer.mobile = this.customer_mobile;
    var {
      customer_id,
      customer_name,
      mobile,
      email,
      customer_surname,
      customer_prefix,
      customer_middle_name,
      customer_prosonalcard,
      customer_nationality,
      customer_race,
      customer_birthday,
      created_date,
      edit_date,
    } = this.edit_customer;
    //console.log(this.edit_customer);
    if (
      !(
        customer_name == "" ||
        mobile == "" ||
        customer_prosonalcard == "" ||
        customer_name == "" ||
        customer_surname == "" ||
        customer_prefix == ""
      )
    ) {
      this.isLoading = true;
      this.service.postData(this.edit_customer, this.action.hostUrl).then(
        (result: any) => {
          this.isLoading = false;
          if (!result.code) {
            Swal.fire({
              title: this.language.saved,
              text: "",
              type: "success",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
            }).then((result) => {
              this.getCustomerData();
            });
          }
        },
        (err) => {
          window.location.href = this.service.start_host;
        }
      );
    }
  }
  delete_customer(customer_data) {
    Swal.fire({
      title: this.language.confirm_delete,
      text: this.language.warning_delete,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close_page,
    }).then((result) => {
      if (result.value) {
        this.isLoading = true;
        this.service
          .postData(
            { customer_id: customer_data.customer_id },
            "customer/delete"
          )
          .then(
            (result: any) => {
              this.isLoading = false;
              if (!result.code) {
                Swal.fire({
                  title: this.language.deleted,
                  text: "",
                  type: "success",
                  showCancelButton: false,
                  showConfirmButton: false,
                  timer: 2000,
                }).then((result) => {
                  this.getCustomerData();
                });
              }
            },
            (err) => {
              window.location.href = this.service.start_host;
            }
          );
      }
    });
  }
  view_place(customer_data) {
    this.view_place_customer = customer_data;
    this.place_customer.customer_id = customer_data.customer_id;
    this.refresh_customer_place();
  }
  refresh_customer_place() {
    this.action = this.actions[3];
    this.submitted = false;
    this.place_customer = {
      customer_id: this.place_customer.customer_id,
      place_id: "",
      place_description: "",
      place_address: "",
      tambol: "",
      amphur: "",
      province: "",
      postcode: "",
      remark: "",
      place_type_id: "",
      lat: "",
      lon: "",
      place_pic: "",
      place_mobile: "",
      place_owner: "",
    };
    this.isLoading = true;

    this.search_place_address = "";
    this.place_id = "";
    this.place_ids = [];
    this.place_customer = {
      customer_id: "",
      place_id: "",
      place_description: "",
      place_address: "",
      tambol: "",
      amphur: "",
      province: "",
      postcode: "",
      remark: "",
      place_type_id: "",
      lat: "",
      lon: "",
      place_pic: "",
      place_mobile: "",
      place_owner: "",
    };
    this.customer_request = {
      request_id: "",
      customer_name: "",
      lat: "",
      lon: "",
      coordinates: "",
      remark: "",
      flag: "",
      user_id: "",
      request_date: "",
      request_type: "",
      request_desc: "",
    };
    this.request_ids = {
      customer_name: "",
      customer_surname: "",
      mobile: "",
      place_type_description: "",
      request_desc: "",
    };
    this.admin_id = "";
    this.temp_tambon = "";
    this.temp_amphoe = "";
    this.temp_province = "";
    this.temp_postcod = "";
    this.service
      .postData(
        { customer_id: this.view_place_customer.customer_id },
        this.action.hostUrl
      )
      .then((result: any) => {
        this.isLoading = false;
        if (!result.code) {
          this.all_place = result.data;

          this.places = result.data;
        }
      });
  }

  add_place() {
    // debugger
    this.action = this.actions[4];
    this.isLoading = true;
    this.show_radio_btn = true;
    this.place_customer.place_mobile = this.view_place_customer.mobile;
    this.service
      .postData(
        { customer_id: this.view_place_customer.customer_id },
        "customer-place/getId"
      )
      .then((result: any) => {
        console.log(result);
        if (!result.code) {
          this.place_customer.place_id = result.max_id;
        }
      });

    this.service
      .postData(
        { customer_id: this.view_place_customer.customer_id },
        "customer-request/get-customer-request"
      )
      .then((result: any) => {
        // debugger
        console.log(result);
        this.isLoading = false;
        this.request_ids = {
          customer_name: "",
          customer_surname: "",
          mobile: "",
          place_type_description: "",
          request_desc: "",
        };

        console.log(this.request_ids);
        this.request_ids = result.data;
        // this.request_ids.customer_name = !result.data[0].customer_name ? null : result.data[0].customer_name;
        // this.request_ids.customer_surname = !result.data[0].customer_surname ? null : result.data[0].customer_surname;
        // this.request_ids.mobile = !result.data[0].mobile ? null : result.data[0].mobile;
        // this.request_ids.place_type_description = !result.data[0].place_type_description ? null : result.data[0].place_type_description;
        // this.request_ids.request_desc = !result.data[0].request_desc ? null : result.data[0].request_desc;
      });

    this.service.postData({}, "place-type/get").then(
      (result: any) => {
        this.isLoading = false;
        this.place_types = result.data;
        setTimeout(() => {
          var streets_satellite = L.tileLayer(
            "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
            {
              attribution: "Mapbox",
              tileSize: 512,
              zoomOffset: -1,
              id: "mapbox/satellite-v9",
              accessToken:
                "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
            }
          );
          // ===================================================================================
          var mapbox_streets = L.tileLayer(
            "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
            {
              attribution: "Mapbox",
              tileSize: 512,
              zoomOffset: -1,
              id: "mapbox/streets-v11",
              accessToken:
                "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
            }
          );

          var wmslayer = L.tileLayer.wms(
            "http://203.150.210.26:8080/geoserver/gwc/service/wms",
            {
              layers: "Pattaya:Satellite",
              format: "image/png8",
              transparent: true,
            }
          );

          var polygon = L.tileLayer.wms(
            "http://203.150.210.26:8080/geoserver/gwc/service/wms",
            {
              layers: "pattaya_290663",
              format: "image/png8",
              transparent: true,
            }
          );

          var baseLayers = {
            Satellite_mapbox: streets_satellite,
            Streets_mapbox: mapbox_streets,
          };

          let layerControl = L.control.layers(baseLayers);

          // Initialize map and add base layers
          this.map = L.map("map", {
            center: [this.lat, this.lon],
            zoom: 13,
            layers: [streets_satellite],
          });
      
          // Add layer control to map
          layerControl.addTo(this.map);
      
          this.service.postData({}, "zone/get").then(async (e: any) => {
            const newdata = await e.data.map((feature: any) => {
              return {
                zone_id: feature.zone_id,
                id: feature.id,
                geometry: feature.coordinates,
                properties: feature.properties,
                type: feature.type,
                zone_name: feature.zone_name,
                block_coordinates: feature.block_coordinates,
              };
            });
            const newdata_ = await Promise.all(newdata);
            this.mapbox = newdata_;
            const bule = newdata_.filter((feature: any) => feature.zone_idd == null);
      
            var css =
              ".text-label { background-color: transparent; color: white; font-size: 13px; border: none; }";
            var style = document.createElement("style");
            style.type = "text/css";
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
      
            const zone = L.geoJSON(bule, {
              style: { color: "blue", fillOpacity: 0.4 },
              onEachFeature: (feature: any, layer: any) => {
                layer
                  .bindTooltip(feature.zone_id, {
                    permanent: true,
                    direction: "center",
                    className: "text-label",
                    // opacity: 0.9
                  })
                  .openTooltip();
                layer.bindPopup( `<p style="font-size: 12px;">
                โซน: ${feature.zone_name}<br>
                </p>`
                  );
                layer.on('mouseover', function() {
                  this.openPopup();
                });
                layer.on('mouseout', function() {
                  this.closePopup();
                });
              },
            });
            zone.addTo(this.map);
            
            
      
            const newGeoJsonLayer = L.geoJSON(bule, {
              style: { color: "blue", fillOpacity: 0.4 },
              onEachFeature: (feature: any, layer: any) => {
                layer
                  .bindTooltip(feature.zone_name, {
                    permanent: true,
                    direction: "center",
                    className: "text-label",
                    // opacity: 0.9
                  })
                  .openTooltip();
              },
            });
            zone.addTo(this.map);
      
            this.map.on("zoomend", () => {
              if (this.map.getZoom() >= 15) {
                newGeoJsonLayer.addTo(this.map);
                layerControl.addOverlay(newGeoJsonLayer, "New GeoJSON");
                this.map.removeLayer(zone);
              } else {
                this.map.removeLayer(newGeoJsonLayer);
                layerControl.removeLayer(newGeoJsonLayer);
                zone.addTo(this.map);
              }
            });
          });
          var customIcon = L.icon({
            iconUrl: "../../../assets/img/marker-icon-2x.png",
            iconSize: [30, 45],
            iconAnchor: [23, 35],
            popupAnchor: [-2, -38],
          });
          // layerControl.addOverlay(polygon.addTo(this.map), "ขอบเขต");
          this.marker = L.marker([this.lat, this.lon], {
            icon: customIcon,
          }).addTo(this.map);

          this.polygon = L.polygon([[[[this.lat, this.lon]]]]).addTo(this.map);
          this.map.on("click", async (e: any) => {
            if (!this.a) {
              console.log(e);
              this.map.removeLayer(this.marker);
              this.marker = L.marker([e.latlng.lat, e.latlng.lng], {
                icon: customIcon,
              }).addTo(this.map);
              let address = await axios.get(
                `https://www.deemap.com/DeeMap2WS_GC_dtc-ws/geocodingWithPOI.jsp?lat=` +
                  +e.latlng.lat +
                  `&lon=` +
                  +e.latlng.lng +
                  `&radius=1`
              );
              this.admin_id = address.data.tambon[0].ADMIN_CODE;
              this.temp_tambon = address.data.tambon[0].TAM_TNAME;
              this.temp_amphoe = address.data.tambon[0].AMP_TNAME;
              this.temp_province = address.data.tambon[0].PROV_TNAME;
              this.temp_postcod = address.data.tambon[0].POSTCOD;
              this.place_customer.lat = e.latlng.lat;
              this.place_customer.lon = e.latlng.lng;
            }
          });
        });
      },
      (err) => {
        window.location.href = this.service.start_host;
      }
    );
  }

  save_place(data) {
    // debugger
    let req_id = null;
    console.log(this.action);
    if (this.action.id == 5) {
      this.submitted = true;
      console.log(data);
      console.log(this.request_ids);
      console.log(this.edit_customer);
      console.log(this.customer_request);
      (this.place_customer.customer_id = data.customer_id),
      this.place_customer.place_description,
      (this.place_customer.amphur = this.temp_amphoe);
      this.place_customer.tambol = this.temp_tambon;
      this.place_customer.province = this.temp_province;
      this.place_customer.postcode = this.temp_postcod;
      this.place_customer.place_owner = data.customer_name;
      this.place_customer.remark = this.customer_request.remark;
      this.place_customer.place_mobile = data.mobile;
      ;
      console.log(this.place_customer);
      if (
        !this.place_customer.place_type_id ||
        !this.place_customer.place_address ||
        !this.place_customer.tambol ||
        !this.place_customer.amphur ||
        !this.place_customer.province ||
        !this.place_customer.postcode ||
        !this.place_customer.lat ||
        !this.place_customer.lon ||
        !this.place_customer.place_mobile
      ) {
        return Swal.fire({
          title: this.language.data_fil,
          text: "",
          type: "error",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }
      this.isLoading = true;
      console.log(this.place_customer);

      this.service.postData({ 
        latitude: this.place_customer.lat, 
        longitude: this.place_customer.lon 
    }, "zone/get_zone_form_lat_lon").then((result: any) => {
        console.log(result);
        const zone_id = result.data.zoneId;
        const zone_name = result.data.zoneName;
        
        this.service.postData(
            {
                request_id: req_id,
                place_customer: this.place_customer,
                admin_id: this.admin_id,
                zone_id: zone_id
            },
            this.action.hostUrl
        ).then(
            (result) => {
                this.isLoading = false;
                Swal.fire({
                    title: this.language.saved,
                    text: "",
                    type: "success",
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer: 2000,
                }).then((result) => {
                    this.place_customer = {
                        customer_id: this.place_customer.customer_id,
                        place_id: "",
                        place_description: "",
                        place_address: "",
                        tambol: "",
                        amphur: "",
                        province: "",
                        postcode: "",
                        remark: "",
                        place_type_id: "",
                        lat: "",
                        lon: "",
                        place_pic: "",
                        place_mobile: "",
                        place_owner: "",
                    };
                    // Add new
                    this.refresh_customer_place();
                });
            },
            (err) => {
                window.location.href = this.service.start_host;
            }
        );
    }).catch((err) => {
        console.log(err);
        window.location.href = this.service.start_host;
    });
    
    } else {
      console.log(data);
      console.log(this.place_customer);
      console.log(this.request_ids);
      console.log(this.view_place_customer);
      this.submitted = true;
      this.place_customer.amphur = this.temp_amphoe;
      (this.place_customer.customer_id = data.customer_id),
        this.place_customer.place_id,
        this.place_customer.place_description,
        this.place_customer.place_address,
        (this.place_customer.tambol = this.temp_tambon),
        (this.place_customer.amphur = this.temp_amphoe),
        (this.place_customer.province = this.temp_province),
        (this.place_customer.postcode = this.temp_postcod),
        this.place_customer.remark = this.customer_request.remark;
        this.place_customer.place_mobile = data.mobile;
      this.place_customer.place_owner = data.customer_name;
      this.place_customer.place_type_id;
      // this.place_customer.lat = this.request_ids[0].lat,
      // this.place_customer.lon = this.request_ids[0].lon,
      this.place_customer.place_pic, this.place_customer.place_mobile;
      if (
        !this.place_customer.place_type_id ||
        !this.place_customer.place_address ||
        !this.place_customer.tambol ||
        !this.place_customer.amphur ||
        !this.place_customer.province ||
        !this.place_customer.postcode ||
        !this.place_customer.lat ||
        !this.place_customer.lon ||
        !this.place_customer.place_mobile
      ) {
        return Swal.fire({
          title: this.language.data_fil,
          text: "",
          type: "error",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 2000,
        });
      }

      this.isLoading = true;
      console.log(this.place_customer);
      if (this.a == true) {
        req_id = this.customer_request.request_id;
      }
      
      this.service.postData({ 
          latitude: this.place_customer.lat, 
          longitude: this.place_customer.lon 
      }, "zone/get_zone_form_lat_lon").then((result: any) => {
          console.log(result);
          const zone_id = result.data.zoneId;
          const zone_name = result.data.zoneName;
          
          this.service.postData(
              {
                  request_id: req_id,
                  place_customer: this.place_customer,
                  admin_id: this.admin_id,
                  zone_id: zone_id
              },
              this.action.hostUrl
          ).then(
              (result) => {
                  this.isLoading = false;
                  Swal.fire({
                      title: this.language.saved,
                      text: "",
                      type: "success",
                      showCancelButton: false,
                      showConfirmButton: false,
                      timer: 2000,
                  }).then((result) => {
                      this.place_customer = {
                          customer_id: this.place_customer.customer_id,
                          place_id: "",
                          place_description: "",
                          place_address: "",
                          tambol: "",
                          amphur: "",
                          province: "",
                          postcode: "",
                          remark: "",
                          place_type_id: "",
                          lat: "",
                          lon: "",
                          place_pic: "",
                          place_mobile: "",
                          place_owner: "",
                      };
                      // Add new
                      this.refresh_customer_place();
                  });
              },
              (err) => {
                  window.location.href = this.service.start_host;
              }
          );
      }).catch((err) => {
          console.log(err);
          window.location.href = this.service.start_host;
      });
      

      this.service
        .postData(
          {
            customer_id: this.place_customer.customer_id,
            place_id: this.place_customer.place_id,
            coordinates: this.customer_request.coordinates,
          },
          "customer-polygon/create"
        )
        .then(
          (result) => {
            this.isLoading = false;
            Swal.fire({
              title: this.language.saved,
              text: "",
              type: "success",
              showCancelButton: false,
              showConfirmButton: false,
              timer: 2000,
            }).then((result) => {
              this.place_customer = {
                customer_id: this.place_customer.customer_id,
                place_id: "",
                place_description: "",
                place_address: "",
                tambol: "",
                amphur: "",
                province: "",
                postcode: "",
                remark: "",
                place_type_id: "",
                lat: "",
                lon: "",
                place_pic: "",
                place_mobile: "",
                place_owner: "",
              };
              this.refresh_customer_place();
            });
          },
          (err) => {
            window.location.href = this.service.start_host;
          }
        );
    }

    // debugger
    //console.log(this.place_customer);
    console.log(this.customer_request.coordinates);
  }
  edit_place(place) {
    console.log(place);
    this.show_radio_btn = false;
    this.a = false;
    this.place_customer = {
      customer_id: place.customer_id,
      place_id: place.place_id,
      place_description: place.place_description,
      place_address: place.place_address,
      tambol: place.tambon_th,
      amphur: place.amphur_th,
      province: place.province_th,
      postcode: place.admin_id,
      remark: place.remark,
      place_type_id: place.place_type_id,
      lat: place.lat,
      lon: place.lon,
      place_pic: place.place_pic,
      place_mobile: !place.place_mobile
        ? this.view_place_customer.mobile
        : place.place_mobile,
      place_owner: place.place_owner,
    };
    // this.request_ids.mobile = place.place_mobile;
    this.request_ids.customer_name = place.place_owner;
    this.admin_id = place.admin_id;
    this.temp_tambon = place.tambon_th;
    this.temp_amphoe = place.amphur_th;
    this.temp_province = place.province_th;
    this.temp_postcod = place.postcode;
    console.log(this.place_customer);
    this.action = this.actions[5];
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: "all",
          tambon: "",
          postcode: "",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.amphurs = result.data;
        }
      });
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: this.place_customer.amphur,
          tambon: "all",
          postcode: "",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.tambons = result.data;
          //console.log(this.tambons);
        }
      });
    this.service
      .postData(
        {
          province: this.place_customer.province,
          amphur: this.place_customer.amphur,
          tambon: this.place_customer.tambol,
          postcode: "all",
        },
        "get_location"
      )
      .then((result: any) => {
        if (result.code) {
          Swal.fire(result.message, "", "error");
        } else {
          this.postcodes = result.data;
          //console.log(this.postcodes)
        }
      });

    this.service
      .postData({}, "customer-request/get-customer-request")
      .then((result: any) => {
        this.isLoading = false;
        this.request_ids = result.data;
      });

    this.isLoading = true;
    this.service.postData({}, "place-type/get").then(
      (result: any) => {
        this.isLoading = false;
        this.place_types = result.data;
        setTimeout(() => {
          var streets_satellite = L.tileLayer(
            "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
            {
              attribution: "Mapbox",
              tileSize: 512,
              zoomOffset: -1,
              id: "mapbox/satellite-v9",
              accessToken:
                "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
            }
          );
          // ===================================================================================
          var mapbox_streets = L.tileLayer(
            "https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token={accessToken}",
            {
              attribution: "Mapbox",
              tileSize: 512,
              zoomOffset: -1,
              id: "mapbox/streets-v11",
              accessToken:
                "pk.eyJ1IjoidG9uZ3p6enoiLCJhIjoiY2s5N3ZuM3hiMGVzYTNncGt6cnVrZHE4eiJ9.jh_uPx9BkdNpdG1LdhenUw",
            }
          );

          var wmslayer = L.tileLayer.wms(
            "http://203.150.210.26:8080/geoserver/gwc/service/wms",
            {
              layers: "Pattaya:Satellite",
              format: "image/png8",
              transparent: true,
            }
          );

          var polygon = L.tileLayer.wms(
            "http://203.150.210.26:8080/geoserver/gwc/service/wms",
            {
              layers: "pattaya_290663",
              format: "image/png8",
              transparent: true,
            }
          );

          var baseLayers = {
            Satellite_mapbox: streets_satellite,
            Streets_mapbox: mapbox_streets,
          };

          let layerControl = L.control.layers(baseLayers);

          // Initialize map and add base layers
          this.map = L.map("map", {
            center: [this.lat, this.lon],
            zoom: 13,
            layers: [streets_satellite],
          });
      
          // Add layer control to map
          layerControl.addTo(this.map);
      
          this.service.postData({}, "zone/get").then(async (e: any) => {
            const newdata = await e.data.map((feature: any) => {
              return {
                zone_id: feature.zone_id,
                id: feature.id,
                geometry: feature.coordinates,
                properties: feature.properties,
                type: feature.type,
                zone_name: feature.zone_name,
                block_coordinates: feature.block_coordinates,
              };
            });
            const newdata_ = await Promise.all(newdata);
            this.mapbox = newdata_;
            const bule = newdata_.filter((feature: any) => feature.zone_idd == null);
      
            var css =
              ".text-label { background-color: transparent; color: white; font-size: 13px; border: none; }";
            var style = document.createElement("style");
            style.type = "text/css";
            style.appendChild(document.createTextNode(css));
            document.head.appendChild(style);
      
            const zone = L.geoJSON(bule, {
              style: { color: "blue", fillOpacity: 0.4 },
              onEachFeature: (feature: any, layer: any) => {
                layer
                  .bindTooltip(feature.zone_id, {
                    permanent: true,
                    direction: "center",
                    className: "text-label",
                    // opacity: 0.9
                  })
                  .openTooltip();
                layer.bindPopup( `<p style="font-size: 12px;">
                โซน: ${feature.zone_name}<br>
                </p>`
                  );
                layer.on('mouseover', function() {
                  this.openPopup();
                });
                layer.on('mouseout', function() {
                  this.closePopup();
                });
              },
            });
            zone.addTo(this.map);
            
            
      
            const newGeoJsonLayer = L.geoJSON(bule, {
              style: { color: "blue", fillOpacity: 0.4 },
              onEachFeature: (feature: any, layer: any) => {
                layer
                  .bindTooltip(feature.zone_name, {
                    permanent: true,
                    direction: "center",
                    className: "text-label",
                    // opacity: 0.9
                  })
                  .openTooltip();
              },
            });
            zone.addTo(this.map);
      
            this.map.on("zoomend", () => {
              if (this.map.getZoom() >= 15) {
                newGeoJsonLayer.addTo(this.map);
                layerControl.addOverlay(newGeoJsonLayer, "New GeoJSON");
                this.map.removeLayer(zone);
              } else {
                this.map.removeLayer(newGeoJsonLayer);
                layerControl.removeLayer(newGeoJsonLayer);
                zone.addTo(this.map);
              }
            });
          });
          var customIcon = L.icon({
            iconUrl: "../../../assets/img/marker-icon-2x.png",
            iconSize: [30, 45],
            iconAnchor: [23, 35],
            popupAnchor: [-2, -38],
          });
          this.marker = L.marker([place.lat, place.lon], {
            icon: customIcon,
          }).addTo(this.map);
          this.polygon = L.polygon([[[[place.lat, place.lon]]]]).addTo(this.map);

          this.map.on("click", async (e: any) => {
            if (!this.a) {
              console.log(e);
              this.map.removeLayer(this.marker);
              this.marker = L.marker([e.latlng.lat, e.latlng.lng],{icon: customIcon}).addTo(
                this.map
              );
              let address = await axios.get(
                `https://www.deemap.com/DeeMap2WS_GC_dtc-ws/geocodingWithPOI.jsp?lat=` +
                  +e.latlng.lat +
                  `&lon=` +
                  +e.latlng.lng +
                  `&radius=1`
              );
              this.admin_id = address.data.tambon[0].ADMIN_CODE;
              this.temp_tambon = address.data.tambon[0].TAM_TNAME;
              this.temp_amphoe = address.data.tambon[0].AMP_TNAME;
              this.temp_province = address.data.tambon[0].PROV_TNAME;
              this.temp_postcod = address.data.tambon[0].POSTCOD;
              this.place_customer.lat = e.latlng.lat;
              this.place_customer.lon = e.latlng.lng;

            }
          });
        });
      },
      (err) => {
        window.location.href = this.service.start_host;
      }
    );
  }
  back_place() {
    this.refresh_customer_place();
  }

  delete_place(place) {
    Swal.fire({
      title: this.language.delete_place_alert,
      text: this.language.warning_delete,
      type: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: this.language.want_delete,
      cancelButtonText: this.language.close_page,
    }).then((result) => {
      if (result.value) {
        //console.log(place);
        this.isLoading = true;
        this.service
          .postData(
            { customer_id: place.customer_id, place_id: place.place_id },
            "customer-place/delete"
          )
          .then(
            (result) => {
              Swal.fire({
                title: this.language.deleted,
                text: "",
                type: "success",
                showCancelButton: false,
                showConfirmButton: false,
                timer: 2000,
              }).then((result) => {
                this.isLoading = false;
                this.refresh_customer_place();
              });
            },
            (err) => {
              window.location.href = this.service.start_host;
            }
          );
      }
    });
  }
  select_radio(e) {
    console.log(e);
    this.a = e;
    this.b = e;
  }
}
